import AOS from 'aos';

import './utils/vh.utils.js';
import './utils/eq-height.utils.js';
import './utils/parallax-on-view.utils.js';
import './utils/animate-on-view.utils.js';
import './utils/data-tilt.utils.js';
import './utils/meta.utils.js';

import './components/meta/select.component.js';
import './components/meta/input.component.js';

import './components/marquee/_index.js';
import './components/swiper/_index.js';
import './components/cards/_index.js';
import './components/sections/_index.js';
import './components/animations/_index.js';

import './components/validation.component.js';

import './components/uploadFile.component.js';
import './components/range.component.js';
import './components/header.component.js';
import './components/footer-scroll-top.component.js';
import './components/contact-tabs.component.js';
import './components/animations.component.js';
import './components/player.component.js';

import './libs/countUp.lib.js';
/*import './libs/lenis.lib.js';

const lenisScrollTo = (selector) => {
  const target = document.querySelector(selector);

  lenis.scrollTo(target, { offset: -40 });
};

window.lenisScrollTo = lenisScrollTo;*/

AOS.init({
  offset: 10,
  delay: 10,
  duration: 600,
  easing: 'ease-in-out',
  once: true,
  startEvent: 'DOMContentLoaded',
});


const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if(isSafari) document.body.classList.add('is-safari');
